import React from 'react';

import useDataFetcher from '../../useDataFetcher';
import type { LegalActionApiResponse } from '../types';

import { useLegalActionsBackendRoutes } from './useLegalActionsBackendRoutes';

const LegalActionContext = React.createContext<{
  legalAction: LegalActionApiResponse | undefined;
  isLoading: boolean;
  isError: boolean;
  reloadLegalAction: () => Promise<void>;
}>({
  legalAction: undefined,
  isLoading: true,
  isError: false,
  reloadLegalAction: async () => {},
});

export const LegalActionContextProvider: React.FC<React.PropsWithChildren<{ legalActionId: number }>> = ({
  children,
  legalActionId,
}) => {
  const backendRoutes = useLegalActionsBackendRoutes(legalActionId);

  const {
    data: legalAction,
    isLoading,
    isError,
    reloadData: reloadLegalAction,
  } = useDataFetcher<LegalActionApiResponse>(backendRoutes.legalAction.base, {}, Boolean(legalActionId));

  return (
    <LegalActionContext.Provider
      value={{
        legalAction,
        isLoading,
        isError,
        reloadLegalAction: async () => {
          await reloadLegalAction();
        },
      }}
    >
      {children}
    </LegalActionContext.Provider>
  );
};

export const useLegalAction = (): {
  legalAction: LegalActionApiResponse | undefined;
  isLoading: boolean;
  isError: boolean;
  reloadLegalAction: () => Promise<void>;
} => {
  return React.useContext(LegalActionContext);
};
